import type { Intent } from '@jet/environment/dispatching';

export enum PaginationIntentKind {
    Name = 'PaginationIntent',
}

export interface PaginationIntent extends Intent<unknown> {
    $kind: PaginationIntentKind.Name;

    /**
     * The pagination next path from the response metadata
     */
    path?: string;

    itemType?: string;
    limit?: number;
}

export function isPaginationIntent(
    intent: Intent<unknown>,
): intent is PaginationIntent {
    return intent.$kind === PaginationIntentKind.Name;
}

export function makePaginationIntent(
    options: Omit<PaginationIntent, '$kind'>,
): PaginationIntent {
    return {
        ...options,
        $kind: PaginationIntentKind.Name,
    };
}
